import script from "./VensoOrderGroup.vue?vue&type=script&setup=true&lang=ts"
export * from "./VensoOrderGroup.vue?vue&type=script&setup=true&lang=ts"

import "./VensoOrderGroup.vue?vue&type=style&index=0&id=6ecfefad&scoped=true&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-6ecfefad"]])

export default __exports__